<style scoped>
.cost-echarts {
  overflow: hidden;
  padding-top: 50px;
}
.roseCharts {
  float: left;
  margin-bottom: 30px;
}
.roseCharts:nth-child(2n) {
  float: right;
}
.el-col-5 {
  width: 28%;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="5"
          ><div class="search-area-div">年度：</div>
          <el-date-picker v-model="page.year" type="year" placeholder="选择年"> </el-date-picker
        ></el-col>
        <el-col :span="5"
          ><div class="search-area-div">月度：</div>
          <el-select class="w70f" v-model="page.month" placeholder="请选择" :clearable="true">
            <el-option v-for="item in optionsMonth" :key="item.value" :label="item.label" :value="item.value">
            </el-option> </el-select
        ></el-col>
        <el-col :span="5">
          <el-button size="medium" type="info" @click="searchData()">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff cost-echarts p16 mt15">
      <div class="roseCharts" v-loading="loading" :style="{ width: '50%', height: '500px' }" @click="toDetail"></div>
    </div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require('echarts/lib/echarts');
// 引入柱状图组件
require('echarts/lib/chart/bar');
// 引入提示框和title组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
export default {
  data() {
    return {
      value: '',
      value1: '',
      value2: '',
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        medGuid: '',
        year: '',
        month: '',
        invoiceState: '',
        supplierName: '',
        paymentState: '',
      },
      optionsMonth: [
        { label: '01', value: '01' },
        { label: '02', value: '02' },
        { label: '03', value: '03' },
        { label: '04', value: '04' },
        { label: '05', value: '05' },
        { label: '06', value: '06' },
        { label: '07', value: '07' },
        { label: '08', value: '08' },
        { label: '09', value: '09' },
        { label: '10', value: '10' },
        { label: '11', value: '11' },
        { label: '12', value: '12' },
      ],
      fillReceiptData: [],
      resData: [
        {
          id: 1,
          name: '常熟市中医院',
          costList: [],
        },
      ],
      costList: [],
      loading: false,
    };
  },
  watch: {
    costList: {
      handler(newVal, oldVal) {
        console.log(newVal);
        this.drawLine(newVal);
      },
    },
    page: {
      handler(newValue, oldValue) {
        if (newValue.year == null) {
          this.page.year = '';
        }
      },
      deep: true,
    },
  },
  created() {
    this.getToday();
  },
  mounted() {
    // setTimeout(() => {
    //   this.drawLine();
    // }, 1000);
  },
  methods: {
    // drawLineCopy() {
    //   let echarts = require('echarts');
    //   let roseCharts = document.getElementsByClassName('roseCharts');
    //   for (let i = 0; i < roseCharts.length; i++) {
    //     let myChart = echarts.init(roseCharts[i]);
    //     let costValue = [];
    //     for (let j = 0; j < this.resData[i].costList.length; j++) {
    //       costValue.push(this.resData[i].costList);
    //     }
    //     myChart.setOption({
    //       color: ['#3398DB'],
    //       title: {
    //         text: this.resData[i].name,
    //         subtext: '2020年4月',
    //         x: 'center',
    //         y: 'top',
    //       },
    //       tooltip: {},
    //       xAxis: {
    //         data: ['应付款', '实际到账', '欠款', '应开票', '待开票'],
    //       },
    //       yAxis: {},
    //       series: [
    //         {
    //           type: 'bar',
    //           data: self.costList,
    //         },
    //       ],
    //     });
    //   }
    // },
    getToday() {
      let self = this;
      let date = new Date();
      let year = date.getFullYear();
      let month = date.getMonth() + 1;
      if (month < 10) {
        month = '0' + month;
      }

      self.page.year = year.toString();
      self.page.month = month;
      self.getData();
    },
    //获取数据列表
    getData() {
      let self = this;
      let invoiceState = self.page.invoiceState;
      let medGuid = self.$store.state.medGuid;
      let pageIndex = self.page.pageIndex;
      let pageSize = -1;
      let supplierName = self.page.supplierName;
      let paymentState = self.page.paymentState;
      let month = self.page.month;
      let year = self.page.year && self.$moment(self.page.year).format('yyyy');
      self.loading = true;
      self.api
        .get(
          `/ms-data-business-service/operating-costs/get-operating-costs-list?invoiceState=` +
            invoiceState +
            `&isAck=Y` +
            `&medGuid=` +
            medGuid +
            `&month=` +
            month +
            `&paymentState=` +
            paymentState +
            `&supplierName=` +
            supplierName +
            `&year=` +
            year +
            `&pageIndex=` +
            pageIndex +
            `&pageSize=` +
            pageSize,
        )
        .then((res) => {
          this.loading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.fillReceiptData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
            //应付款
            let payableAmount = 0;
            //实际到账
            let receiptAmount = 0;
            //欠款
            let arrearsAmount = 0;
            //应开票
            let invoicedAmount = 0;
            // //已开票
            let invoiceAmount = 0;
            //待开票
            let beInvoicedAmount = 0;
            if (self.fillReceiptData && self.fillReceiptData.length > 0) {
              console.log(self.fillReceiptData);
              self.fillReceiptData.forEach((item) => {
                payableAmount = Number((payableAmount + item.payableAmount).toFixed(2)); //应付款
                receiptAmount = Number((receiptAmount + item.receiptAmount).toFixed(2)); //实际到账
                invoiceAmount = Number((invoiceAmount + item.invoiceAmount).toFixed(2)); //实际开票
              });
              arrearsAmount = Number((payableAmount - receiptAmount).toFixed(2)); //欠款
              invoicedAmount = Number(receiptAmount.toFixed(2)); //应开票
              beInvoicedAmount = Number((receiptAmount - invoiceAmount).toFixed(2)); //待开票
              self.costList.push(
                payableAmount,
                receiptAmount,
                arrearsAmount,
                invoicedAmount,
                invoiceAmount,
                beInvoicedAmount,
              );
            } else {
              self.costList = [0, 0, 0, 0, 0, 0];
              self.$message.error('暂无数据');
            }
            console.log('costList', self.costList);
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    drawLine(newVal) {
      // 基于准备好的dom，初始化echarts实例
      let echarts = require('echarts');
      let roseCharts = document.getElementsByClassName('roseCharts');
      let myChart = echarts.init(roseCharts[0]);
      // 绘制图表
      myChart.setOption({
        option: true,
        color: ['#3398DB'],
        title: {
          text: '常熟中医院',
          subtext:
            this.page.year &&
            this.$moment(this.page.year).format('yyyy') + '年' + (this.page.month && this.page.month + '月'),
          x: 'center',
          y: 'top',
        },
        tooltip: {
          formatter: function (newVal) {
            return newVal.value.toFixed(2);
          },
        },
        xAxis: {
          data: ['应收款', '已到账', '未收款', '应开票', '已开票', '未开票'],
        },
        yAxis: {},
        series: [
          {
            name: '',
            type: 'bar',
            data: newVal,
            itemStyle: {
              normal: {
                label: {
                  show: true, //开启显示
                  position: 'top', //在上方显示
                  formatter: function (newVal) {
                    return newVal.value.toFixed(2);
                  },
                  textStyle: {
                    //数值样式
                    color: '#333',
                    fontSize: 12,
                  },
                },
              },
            },
          },
        ],
      });
      window.addEventListener('resize', ()=>{myChart.resize()});
    },
    //清空
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        invoiceState: '',
        medGuid: self.$store.state.medGuid,
        month: '',
        paymentState: '',
        supplierName: '',
        year: '',
      };
      self.costList = [];
      self.getData();
    },
    //搜索
    searchData() {
      let self = this;
      self.costList = [];
      self.getData();
    },
    toDetail() {
      let self = this;
      let year = self.page.year && self.$moment(self.page.year).format('yyyy');
      self.$router.push({
        path: '/statisticalReport/statisticalReportDetail',
        query: {
          invoiceState: self.page.invoiceState,
          month: self.page.month,
          paymentState: self.page.paymentState,
          supplierName: self.page.supplierName,
          year: year,
        },
      });
    },
  },
};
</script>